<template>
  <div class="actor">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Genre'
}
</script>
